import { invoke } from 'lodash';
import { useCallback, useState } from 'react';
import talentProfileApi from '../services/talentProfiles';

export const useUpdateRemarkInMeeting = () => {
  const [isLoading, setLoading] = useState(false);

  const updateRemark = useCallback(async (data, options) => {
    try {
      setLoading(true);
      const response = await talentProfileApi.updateMeetingRemarks(data);
      invoke(options, 'onSuccess', response.data);
      setLoading(false);
      return response.data;
    } catch (err) {
      setLoading(false);
      invoke(options, 'onError', err);
      return {};
    }
  }, []);

  return { updateRemark, isLoading };
};
